import {
  MANUAL_REGISTRATION_APPROVAL,
  MANUAL_REGISTRATION_APPROVAL_SUCCESS,
  MANUAL_REGISTRATION_APPROVAL_ERROR,
  MANUAL_REGISTRATION_APPROVAL_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ManualRegistrationApproval = (state = initialState, action) => {
  switch (action.type) {
    case MANUAL_REGISTRATION_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case MANUAL_REGISTRATION_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case MANUAL_REGISTRATION_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case MANUAL_REGISTRATION_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ManualRegistrationApproval;
